<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-grouping.grouping-results"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div class="mb-3 row">
		<div class="col">
			<div class="form-check form-check-inline">
				<input type="checkbox" class="form-check-input" name="preserveExistingGroup" id="preserveExistingGroup"
					   [(ngModel)]="preserveExistingGroup">
				<label class="form-check-label" for="preserveExistingGroup" jhiTranslate="germplasm-grouping.preserve.existing.group">
				</label>
			</div>
		</div>
	</div>
	<div class="mb-3 row">
		<div class="col">
			<div class="form-check form-check-inline">
				<input type="checkbox" class="form-check-input" name="includeDescendants" id="includeDescendants"
					   [(ngModel)]="includeDescendants">
				<label class="form-check-label" for="includeDescendants" jhiTranslate="germplasm-grouping.include.descendants">
				</label>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;
		<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="group()" class="btn btn-primary" [disabled]="isLoading" data-test="continueGroupingButton">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;
		<span jhiTranslate="germplasm-grouping.continue"></span>
	</button>
</div>
